module.exports = __webpack_public_path__ + "static/media/img_technical_03.b7637f6a.png";